import axios from 'axios';
import Element from 'element-ui';
import qs from 'qs';

// axios.defaults.baseURL = 'https://api.saas.yunrui.net/api/';
// axios.defaults.baseURL = 'http://site.zs.yunrui.net/api/';
// axios.defaults.baseURL = '/api';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 50000;
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
let isTokenExpired = false;
// 添加请求拦截器
axios.interceptors.request.use(function (config) {

  // localStorage.setItem('fy-token', 'f4def267e43f14b52afe832bce00c228')
  const fyToken = localStorage.getItem('fy-token')

  if (fyToken) {
    // 请求头携带token
    config.headers['fy-token'] = fyToken
    config.timeout = 300000 //5分钟
  }
  //权限一级php
  let urlAuth = ['release']
  //权限一级python source
  let whitelist = ['need', 'pyadver']

  let newContentUrl = ['admin']

  let urlPath = config.url;

  if (urlPath == '/admin/users/login/login') {
    isTokenExpired = false
  }
  if (isTokenExpired && ['/admin/verify/captcha/refresh', '/login/getVerify', '/admin/users/login/login'].indexOf(urlPath) == -1) {
    // 如果 token 已过期，取消请求
    return Promise.reject(new Error('登录状态过期，请重新登录！'));
  }

  let mediaId = localStorage.getItem("mediaId")
  let urlArr = urlPath.split('/')

  var blobList = ['login/getVerify',
    '/admin/customers/export/exporttemplate',
    '/admin/customers/export/exporterrorexcel',
    '/admin/customers/export/exportcontractexcel',
    '/admin/customers/export/exportinvoiceexcel',
    '/admin/customers/export/exportbankcardexcel',
    // '/admin/customers/export/exportcustomerexcel',
    // '/admin/customers/export/exportprojectexcel',
    // '/admin/customers/export/exportexecuteexcel',
    // '/admin/customers/export/exportpaycollectionexcel',
    '/admin/customers/export/exportExecuteduizhangexcel',
    '/admin/customers/export/exportplateforminvoiceexcel',
    '/admin/customers/export/exportreportexcel'
  ]
  // '/admin/customers/export/exportcontractexcel',
  // '/admin/customers/export/exportinvoiceexcel',
  // '/admin/customers/export/exportbankcardexcel',
  // '/admin/customers/export/exportcustomerexcel',
  // '/admin/customers/export/exportprojectexcel',
  // '/admin/customers/export/exportexecuteexcel',
  // '/admin/customers/export/exportpaycollectionexcel',
  // '/admin/customers/export/exportExecuteduizhangexcel',
  // '/admin/customers/export/exportplateforminvoiceexcel',
  if (blobList.indexOf(urlPath) != -1) {
    config.responseType = 'blob'

  }

  if (urlPath == 'need/submitorder') {
    config.headers["Content-Type"] = 'multipart/form-data'
  }
  if (urlPath == '/admin/verify/captcha/refresh') {
    config.headers["X-Requested-With"] = 'XMLHttpRequest'
  }

  if (whitelist.indexOf(urlArr[0]) != -1) {
    config.baseURL = process.env.VUE_APP_BASE_PYTHON
  } else if (!urlArr[0]) {
    config.baseURL = process.env.VUE_APP_BASE_API_content;
  } else {
    config.baseURL = process.env.VUE_APP_BASE_API;
  }
  // 在发送请求之前做些什么
  if (config.method == 'post') {
    if (whitelist.indexOf(urlArr[0]) != -1 || !urlArr[0]) {
      config.dataSerializer = function (data) {
        return qs.stringify(data, { arrayFormat: "repeat" })
      }
    } else {
      if (mediaId && urlAuth.indexOf(urlArr[0]) != -1) {
        config.data = {
          mediaId: localStorage.getItem("mediaId"),
          ...config.data
        }
      }
      if (!config.data) {
        config.data = {};
      }
      config.data = qs.stringify(config.data);
    }

  } else if (config.method == 'get') {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" })
    }
    if (mediaId && urlAuth.indexOf(urlArr[0]) != -1) {
      config.params = {
        mediaId: localStorage.getItem("mediaId"),
        ...config.params
      }
    }
  }
  return config;

}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);

});



// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  switch (response.status) {
    case 200:
      return response.data;
    case 207:
      return response;
    default:
      Element.Message.error([], response.statusText);
  }
}, error => {
  // 对响应错误做点什么
  if (error.response.status == 403) {
    Element.Message.error(error.response.data.msg);
    // router.replace('/login')
    isTokenExpired = true
    window.location.href = '/#/login'
  }
  if (error.response.status == 404) {
    // router.replace('/login')
    isTokenExpired = true
    window.location.href = '/#/login'
  }
  return Promise.reject(error);
});

export default axios;